import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ResourceTypes, {
  SubunitAssessmentTypes,
} from 'legacy-packages/unit-outline/src/constants';

const useFilterCoTabs = (props) => {
  const {
    isHomePage,
    unitNumber,
    units,
    typeFilters,
    studentPracticeProblems,
    isPreApSubject = false,
  } = props;
  const [filteredTypeFilters, setFilteredTypeFilters] = useState([]);
  /**
   * Keys must match values from: HomeContainer/typeFilters
   * */
  const resourceToFilter = [
    {
      key: 'videos',
      types: [ResourceTypes.EMBEDDED_VIDEO],
    },
    {
      key: 'topic-questions',
      types: [ResourceTypes.PRACTICE_QUESTIONS],
    },
    {
      key: 'progress-checks',
      types: [ResourceTypes.ASSESSMENT],
    },
    {
      key: 'practice-exams',
      types: [ResourceTypes.ASSESSMENT_PE],
    },
    {
      key: 'practice-problems',
      types: [ResourceTypes.SPP],
    },
    {
      key: 'teacher-resources',
      types: [ResourceTypes.URL],
    },
    {
      key: 'student-resources',
      types: [ResourceTypes.URL],
    },
    {
      key: 'assessments',
      types: [ResourceTypes.ASSESSMENT],
    },
    {
      key: 'sources',
      types: [ResourceTypes.SOURCE, ResourceTypes.LTI],
    },
    {
      key: 'more',
      types: [ResourceTypes.URL],
    },
  ];
  const getImportedResourceTypes = (resources, importedResourceTypes) => {
    const _importedResourceTypes = { ...importedResourceTypes };
    resources.forEach(
      ({ __typename }) => (_importedResourceTypes[__typename] = __typename),
    );

    return _importedResourceTypes;
  };

  useEffect(() => {
    if (isHomePage && !Number.isNaN(unitNumber) && units.length > 0) {
      let importedResourceTypes = {};
      units.forEach(({ number, subunits }) => {
        if (unitNumber === number) {
          subunits.forEach(
            ({ resources: subunitResources, type: subunitType }) => {
              // FY-23754 set custom assessment type for PE's since
              // PE is on it own Unit and Subunit
              if (subunitType === SubunitAssessmentTypes.PE) {
                importedResourceTypes[ResourceTypes.ASSESSMENT_PE] =
                  ResourceTypes.ASSESSMENT_PE;
              } else {
                importedResourceTypes = getImportedResourceTypes(
                  subunitResources,
                  importedResourceTypes,
                  subunitType,
                );
              }
            },
          );
        }
      });
      const _typeFilters = [...typeFilters];
      const _filteredTypeFilters = _typeFilters.filter(
        ({ value }) =>
          value === '' ||
          !!resourceToFilter.find(
            ({ key, types }) =>
              key === value &&
              !!types.find((type) => !!importedResourceTypes[type]),
          ),
      );

      setFilteredTypeFilters(_filteredTypeFilters);
    }
  }, [isHomePage, unitNumber, units, studentPracticeProblems]);

  return [isPreApSubject ? typeFilters : filteredTypeFilters];
};

useFilterCoTabs.propTypes = {
  isHomePage: PropTypes.bool.isRequired,
  unitNumber: PropTypes.string.isRequired,
  units: PropTypes.array.isRequired,
  typeFilters: PropTypes.array.isRequired,
};

export default useFilterCoTabs;
